// Import Hooks
import { useDispatch, useSelector } from 'react-redux';
// Import Components
import ModalWindow from '../../../UI/ModalWindow/ModalWindow';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { validateDashboardName } from '../../../../services/validation/validateDashboardName';
import ActionButton from '../../../UI/ActionButton/ActionButton';
// Import Actions
import { dashboardsActions } from '../../../../store/slices/tools/dashboardsSlice';
// Import Function
import { dashboardsEditDashboard } from '../../../../services/web/tools/dashboards/dashboardsEditDashboards';
import { useEffect, useRef } from 'react';

const DashboardsEdit = () => {
  // Create Dispatch Function
  const dispatchAction = useDispatch();
  // Show Dialog State
  const showDialog = useSelector((state) => state.dashboards.showEditDialog);
  // DashboardToEdit
  const dashboardToEdit = useSelector(
    (state) => state.dashboards.activeDashboard
  );
  // Validation
  const formik = useFormik({
    initialValues: {
      dashboardName: dashboardToEdit ? dashboardToEdit.dashboardName : '',
    },
    enableReinitialize: true,
    validate: validateDashboardName,
    onSubmit: (values) => {
      dispatchAction(
        dashboardsEditDashboard(
          dashboardToEdit.dashboardId,
          values.dashboardName
        )
      );
      formik.values.dashboardName = '';
      closeDialog();
    },
  });
  // Action Handlers
  const closeDialog = () => {
    dispatchAction(dashboardsActions.setShowEditDialog(false));
    formik.values.dashboardName = '';
  };
  // Action Buttons
  const actions = (
    <>
      <ActionButton onClick={closeDialog}>Відміна</ActionButton>
      <ActionButton type='submit' onClick={formik.handleSubmit}>
        Зберегти
      </ActionButton>
    </>
  );

  // Set Focus On Input
  const inputRef = useRef();
  useEffect(() => {
    if (showDialog && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showDialog]);

  return (
    <ModalWindow
      actions={actions}
      title={'Змінити назву дашборду'}
      show={showDialog}
      onHide={closeDialog}>
      <Form onSubmit={formik.handleSubmit}>
        <Form.Label>
          Введіть нову назву дашборду{' '}
          {dashboardToEdit && dashboardToEdit.dashboardName}:
        </Form.Label>
        <Form.Control
          ref={inputRef}
          type='text'
          placeholder='Дашборд'
          name='dashboardName'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.dashboardName}
          isInvalid={formik.errors.dashboardName}
        />
        {formik.errors.dashboardName ? (
          <Form.Text>{formik.errors.dashboardName}</Form.Text>
        ) : (
          <Form.Text>
            <br></br>
          </Form.Text>
        )}
      </Form>
    </ModalWindow>
  );
};

export default DashboardsEdit;
